<script>
export default {
  name: "BaseTab",
  props: {
    label: {
      type: String
    },
    active: {
      type: Boolean
    },
    alignment: {
      type: String,
      default: 'HORISONTAL'
    }
  },
  computed: {
    tabClass() {
      let tabClass = '';

      if (this.active) {
        tabClass += ' base-tab--active';
      }

      if (this.alignment === 'VERTICAL') {
        tabClass += ' base-tab--vertical-alignment';
      }

      return tabClass
    }
  }
}
</script>

<template>
<div class="base-tab"
     :class="tabClass"
>
  <span class="base-tab__label">{{label}}</span>
</div>
</template>

<style lang="scss" scoped>
.base-tab {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 35px;
  width: 100%;
  border-bottom: solid 2px transparent;
  background: #fff;
  cursor: pointer;
  &:hover {
    background: #f0f0f0;
  }
  &__label {
    color: #7835a6;
    font-weight: 600;
  }

  &--vertical-alignment {
    border-bottom: none;
    border-left: solid 2px transparent;
  }

  &--active {
    border-color: #fe8f18;
  }
}
</style>